export default[
    {
        name: 'WaitConfirm',
        path: 'WaitConfirm',
        component: () => import('@/pages/BigData/ConfirmCenter/WaitConfirm'),
        meta: { title: '待确认' },
        props(route) {
            return {id: route.query.id}
        },
    },
    {
        name: 'alreadyConfirm',
        path: 'alreadyConfirm',
        component: () => import('@/pages/BigData/ConfirmCenter/alreadyConfirm'),
        meta: { title: '已确认' },
        props(route) {
            return {id: route.query.id}
        },
    },
]